import axios from "axios";
import { toast } from "react-toastify";

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

/**
 * Company Login (Step 1)
 * @param {Object} data - { email, password, safecontact }
 * @returns {Promise<Object>} Response with token or company selection list
 */
export const loginCompany = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/auth/company`, data)
      .then((res) => {
        // If single company or successful login
        if (res.data.data.token) {
          toast.success(res.data.msg);
        }
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

/**
 * Company Login Step 2 (Select from multiple companies)
 * @param {Object} data - { email, password, safecontact, selectedCompanyId }
 * @returns {Promise<Object>} Response with token
 */
export const selectCompanyLogin = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/auth/company-select`, data)
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

